import { __awaiter, __decorate } from "tslib";
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { WebsiteThemeService } from "../../../services/website-theme.service";
import { DomSanitizer } from "@angular/platform-browser";
import { SharedHttp } from "../../../services/http-client.service";
import { AuthService } from "../../../services/auth.service";
let CompanyDocumentationComponent = class CompanyDocumentationComponent {
    constructor(themeService, sanitizer, httpClient, auth) {
        this.themeService = themeService;
        this.sanitizer = sanitizer;
        this.httpClient = httpClient;
        this.auth = auth;
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.companySelectedFiles = [];
        this.companyFilesToUpload = [];
        this.companyFileError = false;
        this.companyFileSize = 2;
        this.uploadClicked = false;
        this.companyDocumentsSubmitted = new EventEmitter();
        this.themeService.getTheme().subscribe((data) => {
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        });
        this.fetchUser();
    }
    ngOnInit() {
    }
    fetchUser() {
        this.auth.fetchUser().then((data) => {
            this.user = JSON.parse(localStorage.getItem('user'));
        });
    }
    companyFileChange(event) {
        this.companyFilesToUpload = this.toArray(event.target.files);
        if (this.companySelectedFiles.length == 0) {
            this.companySelectedFiles = this.companyFilesToUpload;
        }
        else {
            for (let i = 0; i < this.companyFilesToUpload.length; i++) {
                for (let j = 0; j < this.companySelectedFiles.length; j++) {
                    if (this.companyFilesToUpload[i].name === this.companySelectedFiles[j].name) {
                        break;
                    }
                    if (j === this.companySelectedFiles.length - 1) {
                        this.companySelectedFiles = this.companySelectedFiles.concat(this.companyFilesToUpload[i]);
                    }
                }
            }
        }
        document.getElementById('my-file').value = '';
        this.companyValidateFiles();
    }
    companyValidateFiles() {
        for (let i = 0; i < this.companySelectedFiles.length; i++) {
            const fileExtension = this.companySelectedFiles[i].name.split('.').pop();
            const allowed = this.checkFileExtension(fileExtension);
            if (this.companySelectedFiles[i].size > 1024 * 1024 * this.companyFileSize || !allowed) {
                this.companyFileError = true;
                return;
            }
        }
        this.companyFileError = false;
    }
    companyRemoveFile(index) {
        this.companySelectedFiles.splice(index, 1);
        this.companyValidateFiles();
    }
    roundNumber(num, places) {
        return Math.round(num * Math.pow(10, places)) / Math.pow(10, places);
    }
    companySubmit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.uploadClicked = true;
            const files = this.companySelectedFiles;
            const documentationFiles = [];
            const readUploadedFileAsDataURL = (file) => {
                const temporaryFileReader = new FileReader();
                return new Promise((resolve) => {
                    temporaryFileReader.onload = () => {
                        resolve(temporaryFileReader.result);
                        const tempFile = {
                            name: file.name,
                            content: temporaryFileReader.result
                        };
                        documentationFiles.push(tempFile);
                    };
                    temporaryFileReader.readAsDataURL(file);
                });
            };
            for (let i = 0; i < files.length; i++) {
                yield readUploadedFileAsDataURL(files[i]);
            }
            this.httpClient.post('user/documentation', {
                company_id: this.user.company.id,
                documentation_files: documentationFiles
            }).subscribe((success) => {
                this.documentsSubmitted = true;
                this.companyDocumentsSubmitted.emit(true);
            });
        });
    }
    toArray(fileList) {
        return Array.prototype.slice.call(fileList);
    }
    checkFileExtension(fileExtension) {
        const allowedExtensions = ['jpg', 'png', 'jpeg', 'pdf', 'gif', 'JPG', 'JPEG', 'PNG', 'PDF', 'GIF'];
        return allowedExtensions.includes(fileExtension);
    }
};
CompanyDocumentationComponent.ctorParameters = () => [
    { type: WebsiteThemeService },
    { type: DomSanitizer },
    { type: SharedHttp },
    { type: AuthService }
];
__decorate([
    Input()
], CompanyDocumentationComponent.prototype, "documentsSubmitted", void 0);
__decorate([
    Output()
], CompanyDocumentationComponent.prototype, "companyDocumentsSubmitted", void 0);
CompanyDocumentationComponent = __decorate([
    Component({
        selector: 'ecd-company-documentation',
        template: __importDefault(require("./company-documentation.component.html")).default,
    })
], CompanyDocumentationComponent);
export { CompanyDocumentationComponent };
